import {AlertCircleIcon} from '@/components/ui/icon/Icon'
import {StyledWarningLabel} from '@/components/ui/warning-label/style'

export const WarningLabel = ({hideIcons, text}: {hideIcons?: boolean; text: string}) => {
    return (
        <StyledWarningLabel>
            {!hideIcons && <AlertCircleIcon />}
            {text}
        </StyledWarningLabel>
    )
}
